import { customerShowValidate } from '../../application/dtos/customer_show_validate';

export class customerShowEntity {
    constructor({ id,name,social_reason,settings,clients_warehouse,shipping_accounts,country,token,service_phone,email_to_notify,shipments_notifications,state,zipcode,municipality,neighborhood,street,external_number,internal_number,is_national,contact_phone,email,in_out_ad,arrival_ad,ramping_ad,start_process_ad,end_process_ad,exit_truck_ad,operations_by_customer_ad,operations_by_customer_time,stock_ad,stock_time,storage_policies_ad,immex_ssn,rfe_idc,fulfillment,client_type,deleted_at,language,avoid_validations,rfid_by_product,storage_per_pallet_cost,managing_cost,guides_service,cutoff_time }){
        this.id = id;
        this.name = name;
        this.social_reason = social_reason;
        this.settings = settings;
        this.clients_warehouse = clients_warehouse;
        this.shipping_accounts = shipping_accounts;
        this.country = country;
        this.token = token;
        this.service_phone = service_phone;
        this.email_to_notify = email_to_notify;
        this.shipments_notifications = shipments_notifications;
        this.state = state;
        this.zipcode = zipcode;
        this.municipality = municipality;
        this.neighborhood = neighborhood;
        this.street = street;
        this.external_number = external_number;
        this.internal_number = internal_number;
        this.is_national = is_national;
        this.contact_phone = contact_phone;
        this.email = email;
        this.in_out_ad = in_out_ad;
        this.arrival_ad = arrival_ad;
        this.ramping_ad = ramping_ad;
        this.start_process_ad = start_process_ad;
        this.end_process_ad = end_process_ad;
        this.exit_truck_ad = exit_truck_ad;
        this.operations_by_customer_ad = operations_by_customer_ad;
        this.operations_by_customer_time = operations_by_customer_time;
        this.stock_ad = stock_ad;
        this.stock_time = stock_time;
        this.storage_policies_ad = storage_policies_ad;
        this.immex_ssn = immex_ssn;
        this.rfe_idc = rfe_idc;
        this.fulfillment = fulfillment;
        this.client_type = client_type;
        this.deleted_at = deleted_at;
        this.language = language;
        this.avoid_validations = avoid_validations;
        this.rfid_by_product = rfid_by_product;
        this.storage_per_pallet_cost = storage_per_pallet_cost;
        this.managing_cost = managing_cost;
        this.guides_service = guides_service;
        this.cutoff_time = cutoff_time;
    }

    isValid() {
        return customerShowValidate(this);
    }
}